import { Mail } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { PostLoadCard, PostLoadCardHeader } from "./PostLoadCard";

interface ContactInformationCardProps {
  userProfile: {
    phone: string;
    alternate_phone: string;
    email: string;
  };
  contactOptions: {
    primaryPhone: boolean;
    secondaryPhone: boolean;
    email: boolean;
  };
  onContactOptionsChange: (opts: { primaryPhone: boolean; secondaryPhone: boolean; email: boolean }) => void;
}

export default function ContactInformationCard({
  userProfile,
  contactOptions,
  onContactOptionsChange,
}: ContactInformationCardProps) {
  const contacts = [
    {
      id: "phone1",
      label: userProfile.phone ? `${userProfile.phone} (Primary)` : "Primary Phone (Not set)",
      checked: contactOptions.primaryPhone,
      toggle: () => onContactOptionsChange({ ...contactOptions, primaryPhone: !contactOptions.primaryPhone }),
      show: true,
    },
    {
      id: "phone2",
      label: userProfile.alternate_phone ? `${userProfile.alternate_phone} (Alternate Phone)` : "",
      checked: contactOptions.secondaryPhone,
      toggle: () => onContactOptionsChange({ ...contactOptions, secondaryPhone: !contactOptions.secondaryPhone }),
      show: !!userProfile.alternate_phone,
    },
    {
      id: "email1",
      label: userProfile.email || "Email (Not set)",
      checked: contactOptions.email,
      toggle: () => onContactOptionsChange({ ...contactOptions, email: !contactOptions.email }),
      show: true,
    },
  ].filter(c => c.show);

  return (
    <PostLoadCard>
      <PostLoadCardHeader
        icon={<Mail className="h-3.5 w-3.5" style={{ color: "hsl(var(--brand-teal-deep))" }} />}
        title="Contact Information"
        demoHintKey="section.contactInfo"
      />
      <div className="px-3 pb-3 pt-2 space-y-2">
        {contacts.map((c) => (
          <div key={c.id} className="flex items-center gap-2">
            <Checkbox id={c.id} checked={c.checked} onCheckedChange={() => c.toggle()} />
            <Label htmlFor={c.id} className="text-[11px] cursor-pointer text-muted-foreground">
              {c.label}
            </Label>
          </div>
        ))}
      </div>
    </PostLoadCard>
  );
}
